import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/periodoActual`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const getPeriodoActual = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

/**
 * @typedef {Object} PeriodoBody
 * @property {string} startDate
 * @property {string} endDate
 */

/**
 * @param {string|number} id
 * @param {PeriodoBody} body
 * @returns {Promise<boolean>}
 */
export const updatePeriodoActual = async (id, body) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};
